// Mock data for Shree Silos Group of Companies website
// This data can be replaced with backend API responses later

export const companyInfo = {
  parentCompany: "Shree Silos Group of Companies",
  name: "Shree Silos Group of Companies",
  tagline: "Elevating India with Excellence",
  description: "Your trusted partner for comprehensive elevator solutions - from manufacturing to supply of complete elevator kits and components",
  certification: "IS 17900 Compliant",
  experience: "35+",
  employees: "50+",
  facilitySize: "20,000",
  location: "Bangalore, Karnataka, India",
  serviceArea: "All Over India"
};

export const brands = [
  {
    name: "Shree Industries",
    description: "Manufacturing of elevator components and supply of elevator kits",
    focus: "Manufacturing & Supply"
  },
  {
    name: "Silos Elevators", 
    description: "Primary customer-facing brand for elevator solutions and components",
    focus: "Elevator Solutions"
  },
  {
    name: "Silos Meta Technologies",
    description: "Controllers, drives and advanced technological solutions for elevator systems",
    focus: "Technology & Innovation"
  }
];

export const contactInfo = {
  phone: "+91 7026 7725 11",
  alternatePhone: "+91 9980 22 0164",
  email: "info@siloselevators.com",
  salesEmail: "info@siloselevators.com",
  manufacturingUnit1: {
    name: "Manufacturing Unit 1 (M1)",
    address: "Shed No. 6, St. Anthony's Industrial Estate,\nMetro Pillar No. 92, Kanakapura Main Rd,\nJarganahalli, Bengaluru, Karnataka 560078",
    mapLink: "https://share.google/zwfkJB5z1lcuEmHpf"
  },
  manufacturingUnit2: {
    name: "Manufacturing Unit 2 (M2)", 
    address: "75, 4th Cross, 8th Main Rd, 2nd stage,\nJC Industrial Estate, Yelachenahalli,\nBengaluru, Karnataka 560 062",
    mapLink: "https://share.google/faNEtZzfpvUj7eOHR"
  },
  address: "75, 4th Cross, 8th Main Rd, 2nd stage,\nJC Industrial Estate, Yelachenahalli,\nBengaluru, Karnataka 560 062",
  workingHours: "Mon - Sat: 9:00 AM - 6:00 PM"
};

export const socialLinks = {
  facebook: "#",
  linkedin: "#",
  twitter: "#",
  instagram: "#",
  youtube: "#"
};

export const navLinks = [
  { name: "Home", href: "#home" },
  { name: "About", href: "#about" },
  { name: "Products", href: "#products" },
  { name: "Components", href: "#components" },
  // { name: "Projects", href: "#projects" }, // Hidden temporarily - uncomment to show
  { name: "Spares", href: "/spares", isPage: true },
  { name: "Contact", href: "#contact" }
];

export const stats = [
  { value: "35+", label: "Years Experience", suffix: "" },
  { value: "500+", label: "Projects Completed", suffix: "" },
  { value: "50+", label: "Expert Team", suffix: "" },
  { value: "20,000", label: "Sq. Ft. Facility", suffix: "" }
];

// Elevator Kits - Based on Core Working Dynamics
export const elevatorTypes = [
  {
    id: 1,
    name: "Traction Elevators",
    description: "High-performance elevators using steel ropes and counterweights for smooth, efficient vertical transportation. Ideal for mid to high-rise buildings.",
    image: "/images/lifts/TRACTION ELEVATORS.png",
    category: "Core Technology",
    features: ["Energy Efficient", "Smooth Operation", "High Speed", "Low Maintenance"]
  },
  {
    id: 2,
    name: "Hydraulic Elevators",
    description: "Reliable elevators powered by hydraulic systems, perfect for low to mid-rise buildings with heavy load requirements.",
    image: "/images/lifts/HYDRAULIC ELEVATORS.jpg",
    category: "Core Technology",
    features: ["Heavy Load Capacity", "Cost Effective", "Reliable", "Easy Installation"]
  }
];

// Elevator Kits - Based on Use Case
export const products = [
  {
    id: 1,
    name: "Passenger Lift - Home",
    description: "Elegant and compact home lifts designed for residential use. Perfect blend of style, safety and convenience for modern homes.",
    image: "/images/lifts/PASSENGER LIFT FOR HOME.jpg",
    category: "Passenger Lifts"
  },
  {
    id: 2,
    name: "Passenger Lift - Commercial",
    description: "High-capacity commercial elevators built for offices, malls and commercial complexes. Designed for heavy traffic and durability.",
    image: "/images/lifts/PASSENGER LIFT FOR COMMERCIAL USE.jpeg",
    category: "Passenger Lifts"
  },
  {
    id: 3,
    name: "Hospital Lifts",
    description: "Specialized elevators designed for healthcare facilities with stretcher accommodation, smooth operation and emergency features.",
    image: "/images/lifts/HOSPITAL LIFTS.webp",
    category: "Specialized Lifts"
  },
  {
    id: 4,
    name: "Freight Lift",
    description: "Heavy-duty freight elevators for industrial and warehouse applications. Built to handle substantial loads with reliability.",
    image: "/images/lifts/FREIGHT LIFT.jpg",
    category: "Industrial Lifts"
  },
  {
    id: 5,
    name: "Food Lift",
    description: "Dumbwaiter and food service lifts designed for restaurants, hotels and commercial kitchens. Hygienic and efficient.",
    image: "/images/lifts/FOOD LIFT.jpg",
    category: "Specialized Lifts"
  }
];

// Components We Supply
export const components = [
  {
    id: 1,
    name: "Guide Rails",
    description: "Ready stock of sizes 5mm, 9mm & 16mm guide rails for precise elevator alignment and smooth operation.",
    icon: "Ruler",
    specs: ["5mm", "9mm", "16mm"],
    image: "/assets/products/guide-rail/GUIDE RAILS.jpg",
    images: [
      "/assets/products/guide-rail/GUIDE RAILS.jpg",
      "/assets/products/guide-rail/GUIDE RAILS 2.jpg"
    ],
    brands: [
      { name: "Guide Rail Brand", logo: "/assets/products/guide-rail/GUIDE RAIL BRAND.png" }
    ]
  },
  {
    id: 2,
    name: "Landing & Car Mechanisms",
    description: "Landing headers and car operators for various configurations. Available in 2, 3, 4 & 6 panel doors.",
    icon: "DoorOpen",
    specs: ["500mm to 3000mm Width", "1800mm to 3000mm Height", "Center & Telescoping Opening"],
    image: "/assets/products/car-landing-set/FERMATOR LANDING HEADER.png",
    images: [
      "/assets/products/car-landing-set/FERMATOR LANDING HEADER.png",
      "/assets/products/car-landing-set/FER CAR OPERATOR.png",
      "/assets/products/car-landing-set/GENESIS LANDING HEADER.webp",
      "/assets/products/car-landing-set/GENESIS CAR OPERATOR.webp"
    ],
    brands: [
      { name: "Fermator", logo: "/assets/products/car-landing-set/brands/FERMATOR LOGO.png" },
      { name: "Genesis", logo: "/assets/products/car-landing-set/brands/GENESIS LOGO.png" },
      { name: "Wittur", logo: "/assets/products/car-landing-set/brands/WITTUR_LOGO.jpg" }
    ],
    catalogs: [
      { name: "Car Set Catalog", url: "/assets/pdfs/CORE CAR SET 1ST PAGE PHOTO ONLY.pdf" },
      { name: "Landing Set Catalog", url: "/assets/pdfs/CORE LANDING SET 1ST PAGE PHOTO ONLY.pdf" }
    ]
  },
  {
    id: 3,
    name: "Traction Machines",
    description: "Complete range of traction machines from 272kgs up to 3000kgs and beyond for all elevator applications.",
    icon: "Cog",
    specs: ["272kg to 3000kg+", "Geared & Gearless Options"],
    image: "/assets/products/traction-machines/GRD MACHINE.png",
    images: [
      "/assets/products/traction-machines/GRD MACHINE.png",
      "/assets/products/traction-machines/GRD MACHINE 1.png",
      "/assets/products/traction-machines/GRL MACHINE 1.png",
      "/assets/products/traction-machines/GRL.png"
    ],
    brands: [
      { name: "Bharat Bijlee", logo: "/assets/products/traction-machines/brands/BHARAT BIJLEE LOGO.png" },
      { name: "Montanari", logo: "/assets/products/traction-machines/brands/MONTANARI.png" },
      { name: "Sicor", logo: "/assets/products/traction-machines/brands/SICOR LOGO.png" },
      { name: "Monadrive", logo: "/assets/products/traction-machines/brands/MONADRIVE LOGO.png" },
      { name: "Sharp", logo: "/assets/products/traction-machines/brands/SHARP.png" },
      { name: "Hepu Power", logo: "/assets/products/traction-machines/brands/HEPU POWER.png" }
    ]
  },
  {
    id: 4,
    name: "Ropes",
    description: "High-quality elevator ropes in ready stock. 8x19 configuration in 8mm, 10mm, 13mm and 6x19 in 6mm, 8mm.",
    icon: "Cable",
    specs: ["8x19 – 8mm, 10mm, 13mm", "6x19 – 6mm, 8mm"],
    image: "/assets/products/ropes/3-Rope-Image.png",
    images: [
      "/assets/products/ropes/3-Rope-Image.png",
      "/assets/products/ropes/Screenshot 2026-01-04 225122.png"
    ],
    brands: [
      { name: "Usha Martin", logo: "/assets/products/ropes/USHA MARTIN.png" },
      { name: "GW", logo: "/assets/products/ropes/GW.png" }
    ]
  },
  {
    id: 5,
    name: "Controllers & Drives",
    description: "Advanced controllers and drives for Geared Openloop, Geared Closeloop, Gearless and Hydraulic Control Systems.",
    icon: "Cpu",
    specs: ["Geared Openloop", "Geared Closeloop", "Gearless", "Hydraulic"],
    image: "/assets/products/controller/1694000293_NICE1000+.jpeg",
    images: [
      "/assets/products/controller/1694000293_NICE1000+.jpeg",
      "/assets/products/controller/Screenshot 2026-01-04 225651.png",
      "/assets/products/controller/Screenshot 2026-01-04 230250.png"
    ],
    brands: [
      { name: "NICE", logo: "/assets/products/controller/brands/Screenshot 2026-01-04 225551.png" },
      { name: "Monarch", logo: "/assets/products/controller/brands/Screenshot 2026-01-04 225604.png" },
      { name: "STEP", logo: "/assets/products/controller/brands/Screenshot 2026-01-04 225644.png" },
      { name: "Fuji", logo: "/assets/products/controller/brands/Screenshot 2026-01-04 225810.png" }
    ]
  },
  {
    id: 6,
    name: "BIS Approved Cables",
    description: "Flat traveling cables in various configurations with anti-rodent protection.",
    icon: "Zap",
    specs: ["0.75sqmm x 4C/12C/16C/24C", "Anti-rodent", "High Quality"],
    image: "/assets/products/cable/Elevator-Cables-4.jpg",
    images: [
      "/assets/products/cable/Elevator-Cables-4.jpg"
    ],
    brands: [
      { name: "Cable Brand 1", logo: "/assets/products/cable/brands/Screenshot 2026-01-04 232143.png" },
      { name: "Cable Brand 2", logo: "/assets/products/cable/brands/Screenshot 2026-01-04 232153.png" }
    ]
  },
  {
    id: 7,
    name: "LOP & COP Panels",
    description: "Landing and Car Operating Panels with multiple input types, displays and advanced safety access options.",
    icon: "MonitorSmartphone",
    specs: ["Touch & Button Input", "LCD/TFT Display", "Fingerprint/RFID/Face ID Access"],
    image: "/assets/products/lop-cop/Screenshot 2026-01-04 231120.png",
    images: [
      "/assets/products/lop-cop/Screenshot 2026-01-04 231120.png",
      "/assets/products/lop-cop/Screenshot 2026-01-04 231125.png",
      "/assets/products/lop-cop/Screenshot 2026-01-04 231343.png",
      "/assets/products/lop-cop/Screenshot 2026-01-04 231351.png"
    ],
    brands: [
      { name: "Brand 1", logo: "/assets/products/lop-cop/brands/Screenshot 2026-01-04 230900.png" },
      { name: "Brand 2", logo: "/assets/products/lop-cop/brands/Screenshot 2026-01-04 231044.png" },
      { name: "Brand 3", logo: "/assets/products/lop-cop/brands/Screenshot 2026-01-04 231229.png" }
    ]
  }
];

export const infrastructure = {
  title: "State-of-the-Art Infrastructure",
  description: "Two manufacturing units in Bangalore equipped with the latest technology and advanced automation for precision and efficiency in production.",
  features: [
    {
      title: "Manufacturing Unit 1",
      description: "St. Anthony's Industrial Estate, Kanakapura Main Rd, Jarganahalli",
      icon: "Building"
    },
    {
      title: "Manufacturing Unit 2",
      description: "JC Industrial Estate, Yelachenahalli, Bengaluru",
      icon: "Factory"
    },
    {
      title: "Quality Control",
      description: "Quality assured products with rigorous testing",
      icon: "Shield"
    },
    {
      title: "Skilled Workforce",
      description: "50+ trained professionals dedicated to excellence",
      icon: "Users"
    }
  ],
  images: [
    "https://images.pexels.com/photos/257636/pexels-photo-257636.jpeg",
    "https://images.pexels.com/photos/159298/gears-cogs-machine-machinery-159298.jpeg",
    "https://images.pexels.com/photos/1145434/pexels-photo-1145434.jpeg"
  ]
};

export const missionVision = {
  mission: {
    title: "Our Mission",
    description: "To be the one-stop solution for all elevator needs, offering comprehensive range of elevator kits and components that satisfy diverse customer requirements across India."
  },
  vision: {
    title: "Our Vision",
    description: "To be India's leading manufacturer and supplier of innovative elevator solutions, empowering customers with efficient, safe, and reliable vertical transportation systems."
  }
};

export const whyChooseUs = [
  {
    title: "35+ Years Experience",
    description: "Decades of expertise in the elevator industry",
    icon: "Award"
  },
  {
    title: "Quality Assured",
    description: "Products meeting highest quality standards",
    icon: "BadgeCheck"
  },
  {
    title: "Pan India Service",
    description: "Serving customers across all of India",
    icon: "MapPin"
  },
  {
    title: "Expert Team",
    description: "50+ skilled professionals at your service",
    icon: "Users"
  },
  {
    title: "Ready Stock",
    description: "Wide range of components available in ready stock",
    icon: "Package"
  },
  {
    title: "Complete Solutions",
    description: "From elevator kits to individual components",
    icon: "Layers"
  }
];
